import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Landing from '@/pages/Landing';
import Signup from '@/pages/Signup';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import Onboarding from '@/pages/Onboarding';
import Dashboard from '@/pages/Dashboard';
import MorningCheckIn from '@/pages/MorningCheckIn';
import MiddayNudge from '@/pages/MiddayNudge';
import EveningReflection from '@/pages/EveningReflection';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import AppFooter from '@/components/AppFooter';
import SOS from '@/pages/SOS';
import MyProgress from '@/pages/MyProgress';
import Settings from '@/pages/Settings';
import ModuleViewer from '@/pages/ModuleViewer';
import AdminDashboard from '@/pages/AdminDashboard';
import ProtectedRoute from '@/components/ProtectedRoute';
import '@/App.css';

function AppRouter() {
  const location = useLocation();
  
  // Check for session_id synchronously during render (not in useEffect)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/onboarding" element={<ProtectedRoute requireOnboarding={false}><Onboarding /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/morning-checkin" element={<ProtectedRoute><MorningCheckIn /></ProtectedRoute>} />
      <Route path="/midday-nudge" element={<ProtectedRoute><MiddayNudge /></ProtectedRoute>} />
      <Route path="/evening-reflection" element={<ProtectedRoute><EveningReflection /></ProtectedRoute>} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/sos" element={<ProtectedRoute><SOS /></ProtectedRoute>} />
      <Route path="/progress" element={<ProtectedRoute><MyProgress /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/modules/:moduleId" element={<ProtectedRoute><ModuleViewer /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App flex flex-col min-h-screen">
      <BrowserRouter>
        <div className="flex-1">
          <AppRouter />
        </div>
        <AppFooter />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
